// For API endpoints (RTK Query)

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const blogApi = createApi({
  reducerPath: "blogApi",
  baseQuery: fetchBaseQuery({ baseUrl: "/api/v1", credentials: "include" }),
  tagTypes: ["Blog", "Blogs", "AdminBlogs", "Comments"],
  endpoints: (builder) => ({
    getBlogs: builder.query({
      query: (params={}) => ({
        url: "/blogs",
        params,
      }),
      providesTags: ["Blog"],
    }),
    getBlogDetails: builder.query({
      query: (id) => `/blogs/${id}`,
      providesTags: ["Blog"],
    }),
    getBlogCategories: builder.query({
      query: () => "/blogs/categories",
      providesTags: ["Blog"],
    }),
    getLatestBlogsPerCategory: builder.query({
      query: () => "/blogs/latest-by-category",
    }),
    updateBlog: builder.mutation({
      query({ id, body }) {
        return {
          url: `/admin/blogs/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Blog", "AdminBlogs"],
    }),
    submitComment: builder.mutation({
      query(body) {
        return {
          url: "/comments",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Blog", "Comments"],
    }),
    getAdminBlogs: builder.query({
      query: () => `/admin/blogs`,
      providesTags: ["AdminBlogs"],
    }),
    createBlog: builder.mutation({
      query(body) {
        return {
          url: "/admin/blogs",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["AdminBlogs"],
    }),

    toggleLikeComment: builder.mutation({
      query: (body) => ({
        url: "/comments/like",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Comments", "Blog"]
    }),

    uploadBlogImages: builder.mutation({
      query({ id, body }) {
        return {
          url: `/admin/blogs/${id}/upload_images`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Blog"],
    }),
    deleteBlogImage: builder.mutation({
      query({ id, body }) {
        return {
          url: `/admin/blogs/${id}/delete_image`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["Blog"],
    }),
    deleteBlog: builder.mutation({
      query(id) {
        return {
          url: `/admin/blogs/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["AdminBlogs"],
    }),
    getBlogComments: builder.query({
      query: (blogId) => `/comments?id=${blogId}`,
      providesTags: ["Comments"],
    }),
    deleteBlogComment: builder.mutation({
      query({ blogId, id }) {
        return {
          url: `/admin/comments?blogId=${blogId}&id=${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Comments", "Blog"]
    }),
    replyToComment: builder.mutation({
      query: (body) => ({
        url: "/comments/reply",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Comments", "Blog"],
    }),
    editReply: builder.mutation({
      query: (body) => ({
        url: "/comments/reply/update",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Blog", "Comments"]
    }),
    deleteReply: builder.mutation({
      query: ({ blogId, commentId, replyId }) => ({
        url: "/comments/reply",
        method: "DELETE",
        body: { blogId, commentId, replyId },
      }),
      invalidatesTags: ["Blog", "Comments"],
    }),
    
  }),
});

export const {
  useGetAdminBlogsQuery,
  useGetBlogDetailsQuery,
  useCreateBlogMutation,
  useGetBlogsQuery,
  useDeleteBlogMutation,
  useDeleteBlogImageMutation,
  useUploadBlogImagesMutation,
  useSubmitCommentMutation,
  useLazyGetBlogCommentsQuery,
  useDeleteBlogCommentMutation,
  useToggleLikeCommentMutation,
  useReplyToCommentMutation,
  useEditReplyMutation,
  useDeleteReplyMutation,
  useGetLatestBlogsPerCategoryQuery,
  useGetBlogCategoriesQuery,
  useUpdateBlogMutation
} = blogApi;
